export class OvertimeDeservedRequest {
    employeeId: number;
    overtimeType: number;
}
